import { useState, useEffect } from   'react';
import { NavLink} from 'react-router-dom';
import DataTable from 'react-data-table-component';
import apiService from '../../Auth/apiService';
import { useForm } from 'react-hook-form';
import SweetAlert2 from 'react-sweetalert2';
import { FaUsers } from 'react-icons/fa';
import { useAuth } from '../../Auth/AuthContext';

export default function Entidades(){
    const { token } = useAuth();
    const [datos, setDatos] = useState([]);
    const [Cargando, setCargando] = useState(false);
    const { handleSubmit, register, setValue, formState: { errors }} = useForm();
    const [swalProps, setSwalProps] = useState({});
    const [MuestraFormulario, setMuestraFormulario] = useState(false);
    const onSubmit = async (data) => {
        setCargando(true);
        let url;
        url = '/parametros/guardarentidad';
        try {
            const response = await apiService.post(url, data, token);
            if(response.status === 200){
                Mensaje('Guardar entidad', JSON.stringify(response.data));
            }
        } catch (error) {
            if(error.status === 422){
                Mensaje('Guardar entidad', JSON.stringify(error.response.data.errors));
            }else if(error.status === 409){
                Mensaje('Guardar entidad', JSON.stringify(error.response.data));
            }
            console.error('Error fetching data:', error);
        } finally {
            setCargando(false);
            fetchData();
            ResetForm();
        }
    };
    const Mensaje = (title, text) => {
        setSwalProps({
            show: true,
            title: title,
            text: text,
        });
    };
    const ResetForm = () => {
        setValue('id', 0);
        setValue('entEntidad', '');
        setValue('entDireccion', '');
        setValue('entAh', false);
        setValue('entActivo', false);
        setMuestraFormulario(false);
    }
    const NuevoEntidad = () =>  {
        setValue('id', 0);
        setValue('entEntidad', '');
        setValue('entDireccion', '');
        setValue('entAh', false);
        setValue('entActivo', false);
        setMuestraFormulario(true);
    }

    function handleEdit (row){
        setMuestraFormulario(true);
        
        setValue('id', row.id);
        setValue('entEntidad', row.entEntidad);
        setValue('entDireccion', row.entDireccion);
        setValue('entAh', row.entAh);
        setValue('entActivo', row.entActivo);
    };
    const columns = [
        {
            name: 'Acciones',
            cell: row => (
            <div>
                <button onClick={() => handleEdit(row)} 
                        style={{backgroundColor: 'skyblue'}} 
                        data-tooltip-id='tooltiparriba'
                        data-tooltip-content="Editar">
                <FaUsers/>
                </button>
                
            </div>
            ),
            ignoreRowClick: true,
            width: '7%'
        },
        { name: 'Id', selector: row => row.id, sortable: true, width:'10%' },
        { name: 'Entidad', selector: row => row.entEntidad, sortable: true, width: '25%'},
        { name: 'Dirección', selector: row => row.entDireccion, sortable: true, width: '25%'},
        { name: 'AH', selector: row => row.entAh?'Activo':'Inactivo', sortable: true, width: '25%'},
        { name: 'Estado', selector: row => row.entActivo?'Activo':'Inactivo', sortable: true, width: '7%' }
        ];

    const fetchData = async () => {
        let url = '/parametros/listarentidades';
        try {
        setCargando(true);
        const response = await apiService.get(url, token);
        const result = await response.data;
        setDatos(result);
        } catch (error) {
        console.error('Error fetching data:', error);
        } finally {
        setCargando(false);
        }
    };

    useEffect(() => {
        fetchData();
        }, []);

    return (
        <div className="content-wrapper">
            <section className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                    <div className="col-sm-6">
                        <h1 className="m-0">Entidades</h1>
                    </div>
                    <div className="col-sm-6">
                        <ol className="breadcrumb float-sm-right">
                        <li className="breadcrumb-item"><NavLink to={`/`} >Inicio</NavLink></li>
                        <li className="breadcrumb-item"><NavLink to={`/parametros`} >Par&aacute;metros</NavLink></li>
                        <li className="breadcrumb-item active"> Entidad</li>
                        </ol>
                    </div>
                    </div>
                </div>
            </section>
            <section className="content">
                <div className="container-fluid">
                      {Cargando && <div className="centered">
                        <div><progress value={null} /></div>
                      </div>}
                </div>
            </section>
            <section className="content">
                <div className="container-fluid">
                    {MuestraFormulario && <div className="card card">
                            <div className='card-header'>
                                <h3 className='card-title'>Formulario entidad</h3>
                                
                            </div>
                            <form className="form-horizontal" onSubmit={handleSubmit(onSubmit)}>
                                <div className="card-body">
                                    
                                    <input hidden {...register('id')}/>
                                    <div className='row'>
                                        <div className='col-md-3'>
                                            <div className="form-group" >
                                                <label htmlFor='entEntidad'>Entidad</label>
                                                <input id='entEntidad' {...register('entEntidad', { required: true })} 
                                                    className="form-control" 
                                                    placeholder="Entidad"/>
                                                {errors.entEntidad && <p style={{color: 'red'}}>Digitar dato</p>}
                                            </div>  
                                        </div>
                                        <div className='col-md-3'>
                                            <div className="form-group" >
                                                <label htmlFor='entDireccion'>Direcci&oacute;n</label>
                                                <input id='entDireccion' {...register('entDireccion', { required: true })} 
                                                    className="form-control" 
                                                    placeholder="Dirección"/>
                                                {errors.entDireccion && <p style={{color: 'red'}}>Digitar dato</p>}
                                            </div>  
                                        </div>
                                    </div>
                                    <div className='row'>
                                        <div className='col-md-3'>
                                            <div className="form-group">
                                                <div className="custom-control custom-switch">
                                                <input type="checkbox" 
                                                    {...register('entAh')}
                                                    className="custom-control-input" id="Switchah"/>
                                                <label className="custom-control-label" htmlFor="Switchah">AH</label>
                                                </div>
                                            </div>
                                        </div>
                                        <div className='col-md-3'>
                                            <div className="form-group">
                                                <div className="custom-control custom-switch">
                                                <input type="checkbox" 
                                                    {...register('entActivo')}
                                                    className="custom-control-input" id="SwitchEstado"/>
                                                <label className="custom-control-label" htmlFor="SwitchEstado">Estado</label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="card-footer">
                                    <div className='row'>
                                        <div className='col-md-1'>
                                            <button type="submit" className="btn btn-info">Guardar</button>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    }   
                    <div className="card card">
                        <div className="card-body">
                            <div className="card-body table-responsive p-0">
                                <button className='form-control' onClick={NuevoEntidad}>Nuevo</button>
                                <DataTable
                                    title="Lista de entidades"
                                    columns={columns}
                                    data={datos}
                                    progressPending={Cargando}
                                    pagination
                                    noDataComponent="No hay datos para mostrar"
                                /> 
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <SweetAlert2 {...swalProps} 
                didClose={() => {
                    setSwalProps({})
                }}/>
        </div>
    );
}